import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/more horiz.svg` */
export const MoreHorizIcon = createTripletGlyphIcon('MoreHorizIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.21844 7.99997C4.21844 8.80323 3.56727 9.45441 2.76401 9.45441C1.96074 9.45441 1.30957 8.80323 1.30957 7.99997C1.30957 7.19671 1.96074 6.54553 2.76401 6.54553C3.56727 6.54553 4.21844 7.19671 4.21844 7.99997Z"
        fill="currentColor"
      />
      <path
        d="M9.45445 8.00001C9.45445 8.80327 8.80327 9.45445 8.00001 9.45445C7.19675 9.45445 6.54557 8.80327 6.54557 8.00001C6.54557 7.19675 7.19675 6.54557 8.00001 6.54557C8.80327 6.54557 9.45445 7.19675 9.45445 8.00001Z"
        fill="currentColor"
      />
      <path
        d="M14.6904 8.00001C14.6904 8.80327 14.0392 9.45445 13.236 9.45445C12.4327 9.45445 11.7815 8.80327 11.7815 8.00001C11.7815 7.19675 12.4327 6.54557 13.236 6.54557C14.0392 6.54557 14.6904 7.19675 14.6904 8.00001Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.10986 7.36377C4.01345 7.36377 4.74644 8.09596 4.74658 8.99951C4.74658 9.90318 4.01353 10.6362 3.10986 10.6362C2.2062 10.6362 1.47314 9.90318 1.47314 8.99951C1.47328 8.09596 2.20628 7.36378 3.10986 7.36377Z"
        fill="currentColor"
      />
      <path
        d="M9.00049 7.36377C9.90398 7.36383 10.636 8.09605 10.6362 8.99951C10.6362 9.90315 9.90411 10.6362 9.00049 10.6362C8.09682 10.6362 7.36377 9.90318 7.36377 8.99951C7.36397 8.09601 8.09694 7.36377 9.00049 7.36377Z"
        fill="currentColor"
      />
      <path
        d="M14.8911 7.36377C15.7945 7.36393 16.5267 8.09611 16.5269 8.99951C16.5269 9.90309 15.7947 10.6361 14.8911 10.6362C13.9874 10.6362 13.2544 9.90318 13.2544 8.99951C13.2546 8.09601 13.9876 7.36377 14.8911 7.36377Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.32767 12C6.32767 13.2049 5.35091 14.1817 4.14601 14.1817C2.94112 14.1817 1.96436 13.2049 1.96436 12C1.96436 10.7951 2.94112 9.81836 4.14601 9.81836C5.35091 9.81836 6.32767 10.7951 6.32767 12Z"
        fill="currentColor"
      />
      <path
        d="M14.1817 12C14.1817 13.2049 13.2049 14.1817 12 14.1817C10.7951 14.1817 9.81834 13.2049 9.81834 12C9.81834 10.7951 10.7951 9.81836 12 9.81836C13.2049 9.81836 14.1817 10.7951 14.1817 12Z"
        fill="currentColor"
      />
      <path
        d="M22.0356 12C22.0356 13.2049 21.0589 14.1817 19.854 14.1817C18.6491 14.1817 17.6723 13.2049 17.6723 12C17.6723 10.7951 18.6491 9.81836 19.854 9.81836C21.0589 9.81836 22.0356 10.7951 22.0356 12Z"
        fill="currentColor"
      />
    </svg>
  ),
});
